/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sub-title[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-size:24px;line-height:32px;font-weight:300;color:#231d19}@media (min-width:1024px){.sub-title[_ngcontent-%COMP%]{font-size:32px;line-height:32px}}main[_ngcontent-%COMP%]{padding-top:0;margin-bottom:24px}footer[_ngcontent-%COMP%]{margin-top:1rem;background-color:#fff}"];
export { styles as styles };
